module.exports = __webpack_public_path__ + "img/list-pattern2.f27dc23.svg";